export class Step {
    constructor(
        private stepNo: number,
        public isCompleted: boolean,
        public isActive: boolean,
        public iconClass: string,
        public iconName: string
    ) {}

    get StepNo(): number {
        return this.stepNo;
    }
}

export class Features {
    featureName:string;
    isActive: boolean;
    integrationName:string;
    authenticationUrl:string;
    username:string;
    password:string;
    clientId:string;
    clientSecret:string;
    serviceUrl1:string;
    serviceUrl2:string;
    serviceUrl3:string;
    serviceUrl4:string;
    featureCode:string;
    dealerId:string;
    tenantId:string;
    brandCode:string;
}